import React from 'react';

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const MONTH = DAY * 30;
const YEAR = DAY * 365;

const TimeAgo = ({ timestamp, showSuffix = true, ...rest }) => {
  const parts = timestamp.match(/\d+/g);
  const isoDate = new Date(
    Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5])
  );

  const then = isoDate.getTime();
  const now = new Date().getTime();
  const seconds = Math.round(Math.abs(now - then) / 1000);
  const suffix = then < now ? 'ago' : 'from now';
  let result = 0;

  if (isNaN(seconds) || typeof seconds === 'undefined') {
    result = 'undefined';
  } else {
    if (seconds < MINUTE) {
      result = 'a minute';
    } else if (seconds < HOUR) {
      result = Math.round(seconds / MINUTE, 10);
      result += result === 1 ? ' minute' : ' minutes';
    } else if (seconds < DAY) {
      result = Math.round(seconds / HOUR, 10);
      result += result === 1 ? ' hour' : ' hours';
    } else if (seconds < WEEK) {
      result = Math.round(seconds / DAY, 10);
      result += result === 1 ? ' day' : ' days';
    } else if (seconds < MONTH) {
      result = Math.round(seconds / WEEK, 10);
      result += result === 1 ? ' week' : ' weeks';
    } else if (seconds < YEAR) {
      result = Math.round(seconds / MONTH, 10);
      result += result === 1 ? ' month' : ' months';
    } else {
      result = Math.round(seconds / YEAR, 10);
      result += result === 1 ? ' year' : ' years';
    }
  }

  return (
    <span {...rest}>
      {result}
      {showSuffix && <span> {suffix}</span>}
    </span>
  );
};

export default TimeAgo;
